import React from "react";
import styled from "styled-components";
import { IMAGE_URL } from "../../api/Api";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 30%; /* Chaque carte occupe 30% de la largeur du conteneur */
  margin: 10px 0; /* Ajustez l'espacement vertical entre les lignes */
  overflow: hidden;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%; /* En mode responsive, chaque carte occupe 100% de la largeur du conteneur */
  }
`;

const CourseImage = styled.img`
  display: flex;
  flex: 1;
  width: 100%;
  object-fit: cover;
`;

const CourseTitle = styled.h3`
  color: var(--text-heading-color, #1e1d4c);
  font: 600 20px Poppins, sans-serif;
  margin: 15px 0;
`;

const CourseDescription = styled.p`
  color: var(--TEXT-CLR, #5e6282);
  font: 500 16px Montserrat, sans-serif;
`;

const CourseCard = ({ id, src, title, content_json }) => {
  const goTo = () => {
    window.open("https://app.toyaloo.africa", "_bank");
  };
  return (
    <Card onClick={goTo}>
      <CourseImage
        src={IMAGE_URL + content_json.images[0]}
        alt={title}
        loading="lazy"
      />
      <CourseTitle>{title}</CourseTitle>
      <CourseDescription>{content_json.description.slice(0, 100)}...</CourseDescription>
    </Card>
  );
};
export default CourseCard;
